import React, { useEffect, useState } from 'react';
import { Typography, CircularProgress, Card, CardContent, Button, Grid } from '@mui/material';
import Layout from '../components/Layout';
import { getAllCourses } from '../service/service';
import { useNavigate } from 'react-router-dom';

const ReviewUpgradedLAR = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const data = await getAllCourses();
        setCourses(data.data);
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const handleEdit = (id, name) => {
    navigate(`/upgraded-lar/${id}/${name}`);
  };

  return (
    <Layout>
      {loading ? (
        <CircularProgress />
      ) : (
        <Grid container spacing={2}>
          {courses.map((course) => (
            <Grid item xs={12} sm={6} md={4} key={course.id}>
              <Card>
                <CardContent>
                  <Typography variant="h5">{course.name}</Typography>
                  <Typography variant="body2">{course.description}</Typography>
                  <Button variant="contained" color="primary" onClick={() => handleEdit(course._id, course.name)} style={{ marginTop: '16px' }}>
                    View Upgraded LAR
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Layout>
  );
};

export default ReviewUpgradedLAR; 